import { useState } from "react";
import { Construction } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";
import {
  updateBuyerAsistenteClientesUnderConstruction,
  useUiPreferences,
} from "@/lib/useUiPreferences";

/**
 * Solo diseñador BNT — oculta WhatsApp/borradores del asistente (pestaña Clientes) al comprador.
 * Activo = comprador ve «En construcción».
 */
export default function BuyerAsistenteClientesUnderConstructionToggle() {
  const { buyerAsistenteClientesUnderConstruction, loading } = useUiPreferences();
  const [saving, setSaving] = useState(false);

  const onToggle = async (checked) => {
    setSaving(true);
    try {
      await updateBuyerAsistenteClientesUnderConstruction(checked);
      toast.success(
        checked
          ? "Asistente Clientes: comprador verá «En construcción»."
          : "Asistente Clientes: funcionalidad visible para el comprador.",
      );
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "No se pudo guardar la preferencia");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      className="rounded-md border border-slate-200 bg-white shadow-sm p-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3"
      data-testid="buyer-asistente-clientes-under-construction-toggle"
    >
      <div className="flex items-start gap-3 min-w-0">
        <div className="rounded-md bg-amber-50 p-2 shrink-0">
          <Construction className="w-5 h-5 text-amber-800" strokeWidth={1.8} />
        </div>
        <div>
          <Label
            htmlFor="buyer-asistente-clientes-uc-switch"
            className="text-sm font-semibold text-[#0F2D5C]"
          >
            Asistente → Clientes en construcción
          </Label>
          <p className="text-xs text-slate-600 mt-1 max-w-xl leading-relaxed">
            Si está activo, el comprador no ve WhatsApp ni borradores sugeridos: solo el aviso «En
            construcción». Desactívelo cuando la integración esté lista. El diseñador sigue viendo el
            contenido real (salvo en vista de prueba como comprador).
          </p>
        </div>
      </div>
      <Switch
        id="buyer-asistente-clientes-uc-switch"
        checked={Boolean(buyerAsistenteClientesUnderConstruction)}
        disabled={loading || saving}
        onCheckedChange={onToggle}
        data-testid="buyer-asistente-clientes-uc-switch"
      />
    </div>
  );
}
